import React from "react";
import { Link } from "react-router-dom";
import { PERMISSION_DENIED } from "../constants/error_types";

export default function ErrorPanel(props) {
  const type = props.type ? props.type : "Unbekannt";
  return (
    <center>
      <div style={{ width: "fit-content" }}>
        <h2 style={{ color: "var(--color-bad)" }}>
          Fehler &nbsp;
          <i className="fas fa-exclamation" />
        </h2>
        <p>Das tut uns leid</p>
        <small style={{ color: "var(--color-text-dark)" }}>
          {errorTypeToMessage(type)}
        </small>
        <br />
        <br />
        <Link to="/">
          <p className="Link">Zur Startseite</p>
        </Link>
      </div>
    </center>
  );

  function errorTypeToMessage(type) {
    if (type === PERMISSION_DENIED) {
      return "Zugriff verweigert";
    }

    return "Unbekannter Fehler";
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorPanel.js